import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getMessageText } from "../../../../../shared/lib";
import { isAvailableForNotifications } from "../../utils";
export var BELL_ICON = 'https://static.beeline.ru/upload/images/icons/18161-img-1.png';
export var NOTIFICATION_ICON = 'https://static.beeline.ru/upload/images/icons/18161-img-2.png';
export var reducerFunction = function reducerFunction(title) {
  return function (state, action) {
    if (action.type === 'remove') {
      return state.filter(function (item) {
        if (item.id === action.id) {
          var _item$notification;
          (_item$notification = item.notification) === null || _item$notification === void 0 || _item$notification.close();
          return false;
        }
        return true;
      });
    }
    if (action.type === 'add') {
      var notification;
      if (isAvailableForNotifications() && document.visibilityState !== 'visible') {
        var _getMessageText;
        notification = new Notification(title !== null && title !== void 0 ? title : 'Новое сообщение', {
          // Выводим сообщение вырезая все html теги
          body: (_getMessageText = getMessageText(action.item.message)) === null || _getMessageText === void 0 ? void 0 : _getMessageText.replace(/<[^>]*>?/gm, ' '),
          // Для планшетов и мобилок
          vibrate: 1,
          silent: false,
          // Не поддерживается в Safari
          image: BELL_ICON,
          icon: BELL_ICON
        });
      }
      return [].concat(_toConsumableArray(state), [_objectSpread(_objectSpread({}, action.item), {}, {
        notification: notification
      })]);
    }
    if (action.type === 'clear') {
      state.forEach(function (el) {
        var _el$notification;
        return (_el$notification = el.notification) === null || _el$notification === void 0 ? void 0 : _el$notification.close();
      });
      return [];
    }
    return state;
  };
};